var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup19841(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 557,
    viewBox: "0 0 309 557",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 352.098,
    y: 154.828,
    width: 98.7424,
    height: 470.014,
    rx: 49.3712,
    transform: "rotate(45 352.098 154.828)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 332.35,
    width: 98.7424,
    height: 470.014,
    rx: 49.3712,
    transform: "rotate(45 332.35 0)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 602.509,
    y: 84.9202,
    width: 98.7424,
    height: 470.014,
    rx: 49.3712,
    transform: "rotate(45 602.509 84.9202)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19841);
export default __webpack_public_path__ + "static/media/Group 19841.4c1aebd50931b2ad97327d3f883cfe92.svg";
export { ForwardRef as ReactComponent };